module.exports = __webpack_public_path__ + "static/media/create_surgery.4096a9de.png";